/* CEO tour — 14 steps. Wide overview of every team's surface. */
export default {
  role: "CEO",
  steps: [
    {
      id: "ceo-welcome",
      route: "/",
      selector: '[data-tour-id="topbar-profile"]',
      titleKey: "tour.ceo.welcome.title", titleFallback: "Welcome aboard, {name}",
      bodyKey: "tour.ceo.welcome.body", bodyFallback: "5-minute walkthrough of Sharda Energy OS. You can replay this any time from the header.",
      side: "bottom",
    },
    {
      id: "ceo-home-kpis",
      route: "/",
      selector: '[data-tour-id="home-kpi-grid"]',
      titleKey: "tour.ceo.kpis.title", titleFallback: "Company KPIs",
      bodyKey: "tour.ceo.kpis.body", bodyFallback: "Revenue, active sites, efficiency, alerts — refreshed every page load.",
      side: "bottom",
    },
    {
      id: "ceo-bom-tile",
      route: "/",
      selector: '[data-tour-id="bom-override-tile"]',
      titleKey: "tour.ceo.bomTile.title", titleFallback: "BOM Override Hotspots",
      bodyKey: "tour.ceo.bomTile.body", bodyFallback: "See exactly what engineers are swapping out vs the standard kit. The Monday digest emails you this same view.",
      side: "top",
    },
    {
      id: "ceo-sales-pipeline",
      route: "/sales/pipeline",
      selector: '[data-tour-id="sales-pipeline"]',
      titleKey: "tour.ceo.pipeline.title", titleFallback: "Pipeline (Kanban)",
      bodyKey: "tour.ceo.pipeline.body", bodyFallback: "Drag deals between stages. Every move is audit-logged.",
      side: "top",
    },
    {
      id: "ceo-configurator",
      route: "/sales/configurator",
      selector: '[data-tour-id="configurator-page"]',
      titleKey: "tour.ceo.config.title", titleFallback: "Quick Configurator",
      bodyKey: "tour.ceo.config.body", bodyFallback: "Price a system in 30 seconds — discount bands enforced by the rules engine.",
      side: "bottom",
    },
    {
      id: "ceo-advanced-designer",
      route: "/sales/configurator/advanced",
      selector: '[data-tour-id="advanced-designer"]',
      titleKey: "tour.ceo.designer.title", titleFallback: "BESS Designer (engineering grade)",
      bodyKey: "tour.ceo.designer.body", bodyFallback: "Full 3-step sizing with live PCS / chemistry / financials. Save → snapshot the BOM forever.",
      side: "top",
    },
    {
      id: "ceo-invoices",
      route: "/sales/invoices",
      selector: '[data-tour-id="invoices-list"]',
      titleKey: "tour.ceo.invoices.title", titleFallback: "Invoices",
      bodyKey: "tour.ceo.invoices.body", bodyFallback: "GST-compliant invoicing, e-invoicing scaffold ready for IRP.",
      side: "top",
    },
    {
      id: "ceo-payments",
      route: "/sales/payments",
      selector: '[data-tour-id="payments-page"]',
      titleKey: "tour.ceo.payments.title", titleFallback: "Payments & collections",
      bodyKey: "tour.ceo.payments.body", bodyFallback: "Money in, money out. Reconciliation queue with one-click match.",
      side: "top",
      optional: true,
    },
    {
      id: "ceo-visits",
      route: "/sales/visits",
      selector: '[data-tour-id="visits-page"]',
      titleKey: "tour.ceo.visits.title", titleFallback: "Field visits map",
      bodyKey: "tour.ceo.visits.body", bodyFallback: "Reps check in with GPS — see who's where, live.",
      side: "top",
    },
    {
      id: "ceo-attendance",
      route: "/hr/attendance",
      selector: '[data-tour-id="attendance-page"]',
      titleKey: "tour.ceo.attendance.title", titleFallback: "Team attendance",
      bodyKey: "tour.ceo.attendance.body", bodyFallback: "Geofenced punch-in/out. Regularisation queue rolls up to Admin.",
      side: "top",
      optional: true,
    },
    {
      id: "ceo-approvals",
      route: "/hr/approvals",
      selector: '[data-tour-id="approvals-page"]',
      titleKey: "tour.ceo.approvals.title", titleFallback: "Approvals queue",
      bodyKey: "tour.ceo.approvals.body", bodyFallback: "Leave, expense, regularisation — everything waiting on a signature lives here.",
      side: "top",
      optional: true,
    },
    {
      id: "ceo-ai-fab",
      route: "/",
      selector: '[data-tour-id="ai-fab"]',
      titleKey: "tour.ceo.ai.title", titleFallback: "AI Sales Assistant",
      bodyKey: "tour.ceo.ai.body", bodyFallback: "Ask anything in English or Hinglish — proposals, GST queries, deal-summaries. Claude Sonnet 4.6 under the hood.",
      side: "left",
    },
    {
      id: "ceo-reports",
      route: "/sales/reports",
      selector: '[data-tour-id="reports-page"]',
      titleKey: "tour.ceo.reports.title", titleFallback: "Reports hub",
      bodyKey: "tour.ceo.reports.body", bodyFallback: "Sales, AR ageing, target attainment, designer throughput. CSV-export everything.",
      side: "top",
      optional: true,
    },
    {
      id: "ceo-replay",
      route: "/",
      selector: '[data-tour-id="tour-button"]',
      titleKey: "tour.ceo.replay.title", titleFallback: "Replay anytime",
      bodyKey: "tour.ceo.replay.body", bodyFallback: "This button lives in the header. Hit it whenever you want to retrace your steps — or hand off to a new exec.",
      side: "bottom",
    },
  ],
};
